import React from "react";
import {
    Card,
    Button,
    Checkbox,
    List as AntList,
    Table
} from "antd";
import { Map, OrderedMap } from "immutable";
import { formatCurrency } from "utilities/currency";
import moment from "moment";
import PropTypes from "prop-types";

const DETAILS_LIST = new OrderedMap({
    title: {
        key: "title",
        label: "Title",
        type: "string",
    },
    closing_balance: {
        key: "closing_balance",
        label: "Closing Balance",
        dataIndex: "sanctioned_limit",
        value: null,
        type: "currency"
    },
    alived_any_loans: {
        label: "Availed Any loan ?",
        key: "alived_any_loans",
        dataIndex: "alived_any_loans",
        value: null,
        type: "bool"
    },
    average_daily_customers: {
        label: "Avg Daily Customers",
        key: "average_daily_customers",
        dataIndex: "average_daily_customers",
        value: null,
        type: "number",
    },
    date_of_incorporation: {
        dataIndex: "business_start_date",
        key: "date_of_incorporation",
        label: "Date of Incorporation",
        type: "date",
        value: null
    },
    last_to_last_fy_turnover_in_lakhs: {
        dataIndex: "business_turnover_last_2_19",
        label: "Business Turnover Last to Last Financial year (In Lakhs)",
        key: "last_to_last_fy_turnover_in_lakhs",
        type: "number",
        value: null
    },
    last_fy_turnover_in_lakhs: {
        dataIndex: "business_turnover_last_2_20",
        label: "Business Turnover Last Financial year (In Lakhs)",
        key: "last_fy_turnover_in_lakhs",
        type: "number",
        value: null,
    },
    current_emi_obligations_in_lakhs: {
        dataIndex: "current_emi_obligations",
        key: "current_emi_obligations_in_lakhs",
        label: "Current EMI Obligations in total (Lakh)",
        type: "number",
        value: null
    },
    current_outstanding: {
        dataIndex: "current_outstanding",
        key: "current_outstanding",
        label: "Current Outstanding ? (In Lakhs)",
        type: "currency",
        value: null
    },
    estimated_turnover_current_fy_in_lakhs: {
        dataIndex: "estimated_turnover_current_fy",
        key: "estimated_turnover_current_fy_in_lakhs",
        label: "Estimated Turnover for Current FY(in_lakhs)",
        value: null,
        type: "number"
    },
    date_of_appointment: {
        dataIndex: "length_of_relationship",
        key: "date_of_appointment",
        label: "Date of Appointment",
        value: null,
        type: "date"
    },
    top_brands_dealing_in: {
        key: "top_brands_dealing_in",
        label: "Top Brands",
        type: "table",
        value: [],
        dataIndex: "top_brands_dealing_in"
    },
});

const BRANDS_COLS = OrderedMap({
    Brand_Name: {
        title: "Brand Name",
        dataIndex: "Brand_Name",
        key: "name",
        align: "center"
    },
    Distributor_Name: {
        title: "Distributor Name",
        dataIndex: "Distributor_Name",
        key: "distributor",
        align: "center"
    },
    Percent_Sale: {
        title: "Percent Sale",
        dataIndex: "Percent_Sale",
        key: "perc_sale",
        align: "center"
    }
});

const ListItem = AntList.Item;
const ListItemMeta = AntList.Item.Meta;

const styles = {
    listDetailKeys: { 
        fontWeight: "700", 
        width:"50%", 
        fontSize: "14px",
        marginLeft: "10px",
        padding: "5px",
        background: "rgba(138, 138, 138, 0.1)" 
    },
    listDetailValues: {
        width:"45%",
        marginLeft: "5%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
        // whiteSpace: "pre-line"
    }
};

class PDToLOSView extends React.Component {

    state = {
        checkedList: [],
        checkAll: false,
        indeterminate: true,
        updatedCaseDetails: DETAILS_LIST
    };

    finalDetails = {};

    componentDidMount() {
        const questionnaire = this.props.caseDetail && new Map(this.props.caseDetail.get("questionnaire"));
        if(questionnaire) {
            this.setState({
                updatedCaseDetails: this.state.updatedCaseDetails
                    .map(_ => {
                        return {
                            ..._,
                            value: questionnaire.getIn([_.dataIndex, "response"])
                        };
                    })
            });
        }
    }

    saveDetails = () => {
        const questionnaire = this.props.caseDetail && new Map(this.props.caseDetail.get("questionnaire"));
        if(questionnaire) {
            if(this.state.checkedList && this.state.checkedList.includes("top_brands_dealing_in")) {
                let top_brands_dealing_in = questionnaire.getIn(["top_brands_dealing_in", "response"]);
                if(top_brands_dealing_in && top_brands_dealing_in.length) {
                    top_brands_dealing_in = top_brands_dealing_in.map(_ => {
                        let name = _["Brand_Name"];
                        let seller_name = _["Distributor_Name"];
                        let value_type = 2;
                        let value = _["Percent_Sale"];
        
                        return {
                            name,
                            seller_name,
                            value_type,
                            value
                        };
                    });
                }
                this.props.updateChannelProductStats(this.props.caseId, top_brands_dealing_in);
            }

            let selectedDetails = this.state.updatedCaseDetails.filter(_ => (this.state.checkedList).includes(_.key));
            if(selectedDetails && selectedDetails.size) {
                this.finalDetails = this.props.caseDetail.get("extra_data") || {};
                selectedDetails.map(_ => {
                    if(_.dataIndex == "length_of_relationship") {
                        this.finalDetails[_.key] = moment().subtract(Number(_.value), "months").format("YYYY-MM-DD");
                    }
                    else if(_.dataIndex === "business_start_date") {
                        this.finalDetails[_.key] = moment(_.value).format("YYYY-MM-DD");
                    }
                    else if(_.key.includes("_in_lakhs")) {
                        this.finalDetails[_.key] = Number(_.value) * 100000;
                    } else {
                        this.finalDetails[_.key] = _.value;
                    }
                });
                let details = this.props.caseDetail.set("extra_data", this.finalDetails);
                this.props.updateCaseDetail(this.props.caseId, details);
            }


        }
    }

    disabledSaveBtn = () => {
        if(this.state.checkedList.length) {
            return false;
        }
        return true;
    }

    onCheckAllChange = e => {
        this.setState({
            checkedList: e.target.checked ? DETAILS_LIST.map(_ => _.key).toList().toArray() : [],
            indeterminate: false,
            checkAll: e.target.checked
        });
    }

    onChangeCheck = (val, e) => {
        if(e.target.checked) {
            this.setState({
                checkedList: [...this.state.checkedList, val]
            });
        } else {
            this.setState({
                checkedList: this.state.checkedList.filter(_ => _ !== val)
            });
        }
    }

    render() {
        const extraDetails = this.props.caseDetail && this.props.caseDetail.get("extra_data");
        return (
            <Card
                title={"Case Details to Save from PD"}
                className={"padless-card"}
                extra={[
                    <Button type={"link"} onClick={this.saveDetails} disabled={!(!this.props.recreditViewOnlyPermission && !this.disabledSaveBtn())} key={"Save Details"}>
                        Save Details In Case
                    </Button>
                ]}
            >
                <AntList
                    className={"p-10"}
                    itemLayout={"horizontal"}
                    dataSource={this.state.updatedCaseDetails.toList().toArray()}
                    renderItem={_ => {
                        if(_.key == "title") {
                            return(
                                <ListItem>
                                    <ListItemMeta
                                        title={(
                                            <div key={_.key} className={"d-flex justify-content-space-between"}>
                                                <div style={{width: "40%"}}>
                                                    <Checkbox
                                                        indeterminate={this.state.indeterminate}
                                                        onChange={this.onCheckAllChange}
                                                        checked={this.state.checkAll}
                                                    />
                                                    <span style={{marginLeft: "10px", fontWeight: "bold"}}>
                                                        Questionnaire
                                                    </span>
                                                </div>
                                                <span style={{width: "30%", fontWeight: "bold"}}>{"Value Saved in Case"}</span>
                                                <span style={{width: "30%", fontWeight: "bold"}}>{"Value Saved in Questionnaire"}</span>
                                            </div>
                                        )}
                                    />
                                </ListItem>
                            );
                        }
                        if(_.type == "table") {
                            return (
                                <ListItem>
                                    <ListItemMeta
                                        title={(
                                            <div key={_.key} className={"d-flex flex-column"}>
                                                <div>
                                                    <Checkbox checked={this.state.checkedList.includes(_.key)} onChange={this.onChangeCheck.bind(null, _.key)} />
                                                    <span style={styles.listDetailKeys}>{_.label}</span>
                                                </div>
                                                <Table
                                                    className={"mt-10"}
                                                    columns={BRANDS_COLS.toList().toArray()}
                                                    dataSource={_.value}
                                                />
                                            </div>
                                        )}
                                    />
                                </ListItem>
                            );
                        }
                        if(_.type == "date") {
                            let value = _.value;
                            if(value && _.key === "date_of_appointment") {
                                value = moment().subtract(Number(value), "months");
                            }
                            return (
                                <ListItem>
                                    <ListItemMeta
                                        title={(
                                            <div key={_.key} className={"d-flex justify-content-space-between"}>
                                                <div style={{width: "40%"}} className={"d-flex"}>
                                                    <Checkbox checked={this.state.checkedList.includes(_.key)} onChange={this.onChangeCheck.bind(null, _.key)} />
                                                    <span style={styles.listDetailKeys}>{_.label}</span>
                                                </div>
                                                <span style={{width: "30%"}}>{extraDetails && extraDetails[_.key] && extraDetails && extraDetails[_.key]._isMomentObject ? extraDetails && extraDetails[_.key].format("DD MMM YYYY") : extraDetails && extraDetails[_.key]}</span>
                                                <span style={{width: "30%"}}>{value && value._isMomentObject ? value.format("DD MMM YYYY") : moment(value).format("DD MMM YYYY")}</span>
                                            </div>
                                        )}
                                    />
                                </ListItem>
                            );
                        }
                        if(_.type == "currency") {
                            return (
                                <ListItem>
                                    <ListItemMeta
                                        title={(
                                            <div key={_.key} className={"d-flex justify-content-space-between"}>
                                                <div style={{width: "40%"}} className={"d-flex"}>
                                                    <Checkbox checked={this.state.checkedList.includes(_.key)} onChange={this.onChangeCheck.bind(null, _.key)} />
                                                    <span style={styles.listDetailKeys}>{_.label}</span>
                                                </div>
                                                <span style={{width: "30%"}}>{formatCurrency(extraDetails && extraDetails[_.key]) || "--"}</span>
                                                <span style={{width: "30%"}}>{formatCurrency(_.value)}</span>
                                            </div>
                                        )}
                                    />
                                </ListItem>
                            );
                        }

                        if(_.key.includes("in_lakhs")) {
                            return (
                                <ListItem>
                                    <ListItemMeta
                                        title={(
                                            <div key={_.key} className={"d-flex justify-content-space-between"}>
                                                <div style={{width: "40%"}} className={"d-flex"}>
                                                    <Checkbox checked={this.state.checkedList.includes(_.key)} onChange={this.onChangeCheck.bind(null, _.key)} />
                                                    <span style={styles.listDetailKeys}>{_.label}</span>
                                                </div>
                                                <span style={{width: "30%"}}>{(extraDetails && extraDetails[_.key] && (Number(extraDetails[_.key]) / 100000).toFixed(2)) || "--"}</span>
                                                <span style={{width: "30%"}}>{_.value}</span>
                                            </div>
                                        )}
                                    />
                                </ListItem>
                            );
                        }

                        return (
                            <ListItem>
                                <ListItemMeta
                                    title={(
                                        <div key={_.key} className={"d-flex justify-content-space-between"}>
                                            <div style={{width: "40%"}} className={"d-flex"}>
                                                <Checkbox checked={this.state.checkedList.includes(_.key)} onChange={this.onChangeCheck.bind(null, _.key)} />
                                                <span style={styles.listDetailKeys}>{_.label}</span>
                                            </div>
                                            <span style={{width: "30%"}}>{extraDetails && extraDetails[_.key] || "--"}</span>
                                            <span style={{width: "30%"}}>{_.value}</span>
                                        </div>
                                    )}
                                />
                            </ListItem>
                        );
                    }}
                />
            </Card>
        );
    }
}

PDToLOSView.propTypes = {
    caseId: PropTypes.number,
    caseDetail: PropTypes.object,
    updateChannelProductStats: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default (PDToLOSView);